import { render, staticRenderFns } from "./QuestionFileSet.vue?vue&type=template&id=275bfa4e&scoped=true&"
import script from "./QuestionFileSet.vue?vue&type=script&lang=js&"
export * from "./QuestionFileSet.vue?vue&type=script&lang=js&"
import style0 from "./QuestionFileSet.vue?vue&type=style&index=0&id=275bfa4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275bfa4e",
  null
  
)

component.options.__file = "QuestionFileSet.vue"
export default component.exports